import * as React from 'react';

function useScrollIntoView<T extends HTMLElement>(
    open: boolean,
    behavior: ScrollBehavior = 'smooth',
    block: ScrollLogicalPosition = 'start',
    inline: ScrollLogicalPosition = 'nearest',
): React.MutableRefObject<T> {
    const ref = React.useRef<T>();
    const scroll = React.useCallback(() => {
        ref.current?.scrollIntoView({
            behavior,
            block,
            inline,
        });
    }, [ref]);
    React.useEffect(() => {
        if (open) {
            scroll();
        }
    }, [open]);
    return ref;
}

export default useScrollIntoView;
